import axios, {AxiosResponse} from 'axios'
import {CriminalOffenceQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/criminal-offences`

const getCriminalOffences = (query: string): Promise<CriminalOffenceQueryResponse> => {
  return axios
    .get(`${URL}?${query}`)
    .then((d: AxiosResponse<CriminalOffenceQueryResponse>) => d.data)
}

export {getCriminalOffences}
